





































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ImageSlideViewer extends Vue {
  @Prop({ default: null }) sources: string[];
  @Prop({ default: 'landscape' }) type: string;
  @Prop({ default: 1.5 }) aspectRatio: number;

  private model: number = 0;
  private cycle: boolean = true;

  get multiple (): boolean {
    return (this.sources && this.sources.length > 1);
  }

  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  public start (): void {
    this.cycle = true;
  }

  public reset (): void {
    this.model = 0;
    this.cycle = false;
  }

}
